import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const NutritionFolateDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const dhfr = getGenePalette(geneColors.DHFR);
  const shmt = getGenePalette(geneColors.SHMT);
  const mthfd1 = getGenePalette(geneColors.MTHFD1);
  const mthfr = getGenePalette(geneColors.MTHFR);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18284_196610)">
        <rect width={1024} height={860} transform="translate(0 176)" fill="white" />
        <g id="folate-diagram">
          <rect width={1024} height={860} transform="translate(0 176)" fill="white" />
          <g id="lines">
            <path
              id="Vector_2"
              d="M675.3 250.742L676 250.742L676 249.342L675.3 249.342L675.3 250.042L675.3 250.742ZM545 250.041L552 254.083L552 246L545 250.041ZM675.3 250.042L675.3 249.342L551.3 249.341L551.3 250.041L551.3 250.741L675.3 250.742L675.3 250.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M215.3 678.742L216 678.742L216 677.342L215.3 677.342L215.3 678.042L215.3 678.742ZM190 678.042L197 682.083L197 674L190 678.042ZM215.3 678.042L215.3 677.342L196.3 677.342L196.3 678.042L196.3 678.742L215.3 678.742L215.3 678.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_4"
              d="M308.742 745.7L308.742 745L307.342 745L307.342 745.7L308.042 745.7L308.742 745.7ZM308.042 803L312.083 796L304.001 796L308.042 803ZM308.042 745.7L307.342 745.7L307.342 796.7L308.042 796.7L308.742 796.7L308.742 745.7L308.042 745.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles">
            <rect width={174} height={28} transform="translate(698 236)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={698.463} y={256.129}>
                Folic Acid and Folate
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <rect width={54} height={36} transform="translate(136 654)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={136.012} y={668.086}>
                DNA/RNA{" "}
              </tspan>
              <tspan x={138.133} y={684.086}>
                synthesis
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <rect width={110} height={20} transform="translate(253 807)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={253.309} y={821.086}>
                Pyrimidine synthesis
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_4">
              <rect width={46} height={36} transform="translate(490 236)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={490.031} y={262.16}>
                  DHF
                </tspan>
              </text>
            </g>
            <g id="lines_4">
              <path
                id="Vector_5"
                d="M513.659 276.7L513.659 276L512.259 276L512.259 276.7L512.959 276.7L513.659 276.7ZM512.959 402L517 395L508.918 395L512.959 402ZM512.959 276.7L512.259 276.7L512.259 395.7L512.959 395.7L513.659 395.7L513.659 276.7L512.959 276.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Cofactor_3">
            <g id="diamond_2">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={411.184} y={381.086}>
                  NADPH
                </tspan>
              </text>
              <g id="Vector_6">
                <mask id="path-28-inside-2_18284_196610" fill="white">
                  <path d="M431 352L456 364.121V389.879L431 402L406 389.879V364.121L431 352Z" />
                </mask>
                <path
                  d="M431 352L456 364.121V389.879L431 402L406 389.879V364.121L431 352Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-28-inside-2_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_3">
              <text
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={680.947} y={892.767}>
                  B3
                </tspan>
              </text>
              <g id="Vector_7">
                <mask id="path-30-inside-3_18284_196610" fill="white">
                  <path d="M689 863L714 875.121V900.879L689 913L664 900.879V875.121L689 863Z" />
                </mask>
                <path
                  d="M689 863L714 875.121V900.879L689 913L664 900.879V875.121L689 863Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-30-inside-3_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_5">
            <g id="diamond_4">
              <text
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={524.947} y={520.767}>
                  B3
                </tspan>
              </text>
              <g id="Vector_8">
                <mask id="path-32-inside-4_18284_196610" fill="white">
                  <path d="M533 491L558 503.121V528.879L533 541L508 528.879V503.121L533 491Z" />
                </mask>
                <path
                  d="M533 491L558 503.121V528.879L533 541L508 528.879V503.121L533 491Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-32-inside-4_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_6">
            <g id="diamond_5">
              <text
                id="label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={524.947} y={597.767}>
                  B3
                </tspan>
              </text>
              <g id="Vector_9">
                <mask id="path-34-inside-5_18284_196610" fill="white">
                  <path d="M533 568L558 580.121V605.879L533 618L508 605.879V580.121L533 568Z" />
                </mask>
                <path
                  d="M533 568L558 580.121V605.879L533 618L508 605.879V580.121L533 568Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-34-inside-5_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_7">
            <g id="diamond_6">
              <text
                id="label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={581.838} y={597.767}>
                  B6
                </tspan>
              </text>
              <g id="Vector_10">
                <mask id="path-36-inside-6_18284_196610" fill="white">
                  <path d="M590 568L615 580.121V605.879L590 618L565 605.879V580.121L590 568Z" />
                </mask>
                <path
                  d="M590 568L615 580.121V605.879L590 618L565 605.879V580.121L590 568Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-36-inside-6_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_8">
            <g id="diamond_7">
              <text
                id="label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={623.047} y={597.086}>
                  Choline
                </tspan>
              </text>
              <g id="Vector_11">
                <mask id="path-38-inside-7_18284_196610" fill="white">
                  <path d="M644 568L669 580.121V605.879L644 618L619 605.879V580.121L644 568Z" />
                </mask>
                <path
                  d="M644 568L669 580.121V605.879L644 618L619 605.879V580.121L644 568Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-38-inside-7_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_9">
            <g id="diamond_8">
              <text
                id="label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={647.087} y={751.767}>
                  FAD
                </tspan>
              </text>
              <g id="Vector_12">
                <mask id="path-40-inside-8_18284_196610" fill="white">
                  <path d="M660 722L685 734.121V759.879L660 772L635 759.879V734.121L660 722Z" />
                </mask>
                <path
                  d="M660 722L685 734.121V759.879L660 772L635 759.879V734.121L660 722Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-40-inside-8_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_10">
            <g id="diamond_9">
              <text
                id="label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={614.2} y={892.767}>
                  B2
                </tspan>
              </text>
              <g id="Vector_13">
                <mask id="path-42-inside-9_18284_196610" fill="white">
                  <path d="M622 863L647 875.121V900.879L622 913L597 900.879V875.121L622 863Z" />
                </mask>
                <path
                  d="M622 863L647 875.121V900.879L622 913L597 900.879V875.121L622 863Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-42-inside-9_18284_196610)"
                />
              </g>
            </g>
          </g>
          <g id="Report titles_5">
            <rect width={42} height={36} transform="translate(490 415)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={490.188} y={441.16}>
                THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={87} height={36} transform="translate(814 692)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={814.375} y={718.16}>
                5-MTHF
              </tspan>
            </text>
          </g>
          <g id="lines_5">
            <mask id="path-45-inside-10_18284_196610" fill="white">
              <path d="M268 633L268 728L216 728L216 633L268 633Z" />
            </mask>
            <path
              d="M216 728L215.3 728L215.3 728.7L216 728.7L216 728ZM216 633L216 632.3L215.3 632.3L215.3 633L216 633ZM268 633L268 632.3L265.833 632.3L265.833 633L265.833 633.7L268 633.7L268 633ZM261.5 633L261.5 632.3L257.167 632.3L257.167 633L257.167 633.7L261.5 633.7L261.5 633ZM252.833 633L252.833 632.3L248.5 632.3L248.5 633L248.5 633.7L252.833 633.7L252.833 633ZM244.167 633L244.167 632.3L239.833 632.3L239.833 633L239.833 633.7L244.167 633.7L244.167 633ZM235.5 633L235.5 632.3L231.167 632.3L231.167 633L231.167 633.7L235.5 633.7L235.5 633ZM226.833 633L226.833 632.3L222.5 632.3L222.5 633L222.5 633.7L226.833 633.7L226.833 633ZM218.167 633L218.167 632.3L216 632.3L216 633L216 633.7L218.167 633.7L218.167 633ZM216 633L215.3 633L215.3 634.979L216 634.979L216.7 634.979L216.7 633L216 633ZM216 638.937L215.3 638.937L215.3 642.896L216 642.896L216.7 642.896L216.7 638.937L216 638.937ZM216 646.854L215.3 646.854L215.3 650.812L216 650.812L216.7 650.812L216.7 646.854L216 646.854ZM216 654.771L215.3 654.771L215.3 658.729L216 658.729L216.7 658.729L216.7 654.771L216 654.771ZM216 662.687L215.3 662.687L215.3 666.646L216 666.646L216.7 666.646L216.7 662.687L216 662.687ZM216 670.604L215.3 670.604L215.3 674.562L216 674.562L216.7 674.562L216.7 670.604L216 670.604ZM216 678.521L215.3 678.521L215.3 682.479L216 682.479L216.7 682.479L216.7 678.521L216 678.521ZM216 686.437L215.3 686.437L215.3 690.396L216 690.396L216.7 690.396L216.7 686.437L216 686.437ZM216 694.354L215.3 694.354L215.3 698.312L216 698.312L216.7 698.312L216.7 694.354L216 694.354ZM216 702.271L215.3 702.271L215.3 706.229L216 706.229L216.7 706.229L216.7 702.271L216 702.271ZM216 710.187L215.3 710.187L215.3 714.146L216 714.146L216.7 714.146L216.7 710.187L216 710.187ZM216 718.104L215.3 718.104L215.3 722.063L216 722.063L216.7 722.063L216.7 718.104L216 718.104ZM216 726.021L215.3 726.021L215.3 728L216 728L216.7 728L216.7 726.021L216 726.021ZM216 728L216 728.7L218.167 728.7L218.167 728L218.167 727.3L216 727.3L216 728ZM222.5 728L222.5 728.7L226.833 728.7L226.833 728L226.833 727.3L222.5 727.3L222.5 728ZM231.167 728L231.167 728.7L235.5 728.7L235.5 728L235.5 727.3L231.167 727.3L231.167 728ZM239.833 728L239.833 728.7L244.167 728.7L244.167 728L244.167 727.3L239.833 727.3L239.833 728ZM248.5 728L248.5 728.7L252.833 728.7L252.833 728L252.833 727.3L248.5 727.3L248.5 728ZM257.167 728L257.167 728.7L261.5 728.7L261.5 728L261.5 727.3L257.167 727.3L257.167 728ZM265.833 728L265.833 728.7L268 728.7L268 728L268 727.3L265.833 727.3L265.833 728ZM216 728L214.6 728L214.6 729.4L216 729.4L216 728ZM216 633L216 631.6L214.6 631.6L214.6 633L216 633ZM268 633L268 631.6L265.833 631.6L265.833 633L265.833 634.4L268 634.4L268 633ZM261.5 633L261.5 631.6L257.167 631.6L257.167 633L257.167 634.4L261.5 634.4L261.5 633ZM252.833 633L252.833 631.6L248.5 631.6L248.5 633L248.5 634.4L252.833 634.4L252.833 633ZM244.167 633L244.167 631.6L239.833 631.6L239.833 633L239.833 634.4L244.167 634.4L244.167 633ZM235.5 633L235.5 631.6L231.167 631.6L231.167 633L231.167 634.4L235.5 634.4L235.5 633ZM226.833 633L226.833 631.6L222.5 631.6L222.5 633L222.5 634.4L226.833 634.4L226.833 633ZM218.167 633L218.167 631.6L216 631.6L216 633L216 634.4L218.167 634.4L218.167 633ZM216 633L214.6 633L214.6 634.979L216 634.979L217.4 634.979L217.4 633L216 633ZM216 638.937L214.6 638.937L214.6 642.896L216 642.896L217.4 642.896L217.4 638.937L216 638.937ZM216 646.854L214.6 646.854L214.6 650.812L216 650.812L217.4 650.812L217.4 646.854L216 646.854ZM216 654.771L214.6 654.771L214.6 658.729L216 658.729L217.4 658.729L217.4 654.771L216 654.771ZM216 662.687L214.6 662.687L214.6 666.646L216 666.646L217.4 666.646L217.4 662.687L216 662.687ZM216 670.604L214.6 670.604L214.6 674.562L216 674.562L217.4 674.562L217.4 670.604L216 670.604ZM216 678.521L214.6 678.521L214.6 682.479L216 682.479L217.4 682.479L217.4 678.521L216 678.521ZM216 686.437L214.6 686.437L214.6 690.396L216 690.396L217.4 690.396L217.4 686.437L216 686.437ZM216 694.354L214.6 694.354L214.6 698.312L216 698.312L217.4 698.312L217.4 694.354L216 694.354ZM216 702.271L214.6 702.271L214.6 706.229L216 706.229L217.4 706.229L217.4 702.271L216 702.271ZM216 710.187L214.6 710.187L214.6 714.146L216 714.146L217.4 714.146L217.4 710.187L216 710.187ZM216 718.104L214.6 718.104L214.6 722.063L216 722.063L217.4 722.063L217.4 718.104L216 718.104ZM216 726.021L214.6 726.021L214.6 728L216 728L217.4 728L217.4 726.021L216 726.021ZM216 728L216 729.4L218.167 729.4L218.167 728L218.167 726.6L216 726.6L216 728ZM222.5 728L222.5 729.4L226.833 729.4L226.833 728L226.833 726.6L222.5 726.6L222.5 728ZM231.167 728L231.167 729.4L235.5 729.4L235.5 728L235.5 726.6L231.167 726.6L231.167 728ZM239.833 728L239.833 729.4L244.167 729.4L244.167 728L244.167 726.6L239.833 726.6L239.833 728ZM248.5 728L248.5 729.4L252.833 729.4L252.833 728L252.833 726.6L248.5 726.6L248.5 728ZM257.167 728L257.167 729.4L261.5 729.4L261.5 728L261.5 726.6L257.167 726.6L257.167 728ZM265.833 728L265.833 729.4L268 729.4L268 728L268 726.6L265.833 726.6L265.833 728Z"
              fill="#1A1A1A"
              mask="url(#path-45-inside-10_18284_196610)"
            />
          </g>
          <g id="Frame 470">
            <rect x={261.7} y={711.7} width={92.6} height={34.6} rx={3.3} fill="white" />
            <rect
              x={261.7}
              y={711.7}
              width={92.6}
              height={34.6}
              rx={3.3}
              stroke="#282828"
              strokeWidth={1.4}
            />
            <g id="Report titles_7">
              <rect width={62} height={36} transform="translate(277 711)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_7"
                fill="#282828"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={277.145} y={737.196}>
                  dTMP
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_8">
            <rect width={62} height={36} transform="translate(277 615)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={275.785} y={641.196}>
                dUMP
              </tspan>
            </text>
          </g>
          <path
            id="Vector 292"
            d="M358.657 633.818L357.975 633.661L357.661 635.025L358.343 635.182L358.5 634.5L358.657 633.818ZM358.5 729.5L366.226 731.876L364.42 723.997L358.5 729.5ZM358.5 634.5L358.343 635.182C390.243 642.526 414.693 650.132 431.39 657.873C439.739 661.744 446.118 665.634 450.516 669.519C454.919 673.407 457.275 677.233 457.721 680.974C458.165 684.691 456.74 688.486 453.228 692.368C449.707 696.259 444.132 700.188 436.408 704.123C420.964 711.991 397.111 719.797 364.481 727.411L364.64 728.093L364.8 728.774C397.463 721.153 421.447 713.316 437.043 705.37C444.839 701.399 450.584 697.378 454.266 693.307C457.957 689.228 459.617 685.048 459.111 680.808C458.608 676.59 455.978 672.475 451.443 668.47C446.903 664.46 440.391 660.503 431.978 656.603C415.151 648.801 390.592 641.169 358.657 633.818L358.5 634.5Z"
            fill="#282828"
          />
          <g id="Report titles_9">
            <rect width={115} height={36} transform="translate(435 711)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={435.09} y={737.16}>
                5,10-MTHF
              </tspan>
            </text>
          </g>
          <path
            id="Ellipse 5"
            d="M547 402.947L555.082 402.844L550.952 395.896L547 402.947ZM888 594H887.3C887.3 621.346 882.385 647.543 873.39 671.756L874.046 672L874.702 672.244C883.754 647.877 888.7 621.515 888.7 594H888ZM664 370V370.7C787.325 370.7 887.3 470.675 887.3 594H888H888.7C888.7 469.902 788.098 369.3 664 369.3V370ZM552.411 399.73L552.761 400.336C585.512 381.484 623.495 370.7 664 370.7V370V369.3C623.244 369.3 585.02 380.151 552.062 399.123L552.411 399.73Z"
            fill="#282828"
          />
          <path
            id="Ellipse 5_2"
            d="M827.607 747L819.842 749.242L825.666 754.846L827.607 747ZM823.238 751.541L822.741 751.048C782.266 791.957 726.093 817.3 664 817.3V818V818.7C726.482 818.7 783.009 793.196 823.736 752.033L823.238 751.541ZM664 818V817.3C599.648 817.3 541.654 790.079 500.904 746.522L500.393 747L499.881 747.478C540.885 791.307 599.244 818.7 664 818.7V818Z"
            fill="#282828"
          />
          <path
            id="Ellipse 5_3"
            d="M476.5 711L475.72 702.955L469.143 707.653L476.5 711ZM472.837 705.871L473.422 705.488C464.323 691.611 456.138 670.601 450.225 649.591C444.313 628.581 440.7 607.665 440.7 594H440H439.3C439.3 607.848 442.949 628.904 448.878 649.97C454.806 671.036 463.038 692.204 472.252 706.255L472.837 705.871ZM440 594H440.7C440.7 545.681 456.046 500.948 482.131 464.407L481.561 464L480.992 463.593C454.743 500.364 439.3 545.38 439.3 594H440Z"
            fill="#282828"
          />
          <g id="gene-DHFR" {...geneGroupProps("DHFR", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M390 294C390 291.791 391.791 290 394 290H486C488.209 290 490 291.791 490 294V330C490 332.209 488.209 334 486 334H394C391.791 334 390 332.209 390 330V294Z"
                fill={dhfr.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={409.707} y={320.16}>
                  DHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="dhfr"
              groupId="gene-snps"
              genePalette={dhfr}
              startX={398}
              startY={336}
              snpCount={getGeneSnpCount("DHFR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SHMT" {...geneGroupProps("SHMT", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M390 498C390 495.791 391.791 494 394 494H486C488.209 494 490 495.791 490 498V534C490 536.209 488.209 538 486 538H394C391.791 538 390 536.209 390 534V498Z"
                fill={shmt.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={408.91} y={524.16}>
                  SHMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="shmt"
              groupId="gene-snps_2"
              genePalette={shmt}
              startX={398}
              startY={540}
              snpCount={getGeneSnpCount("SHMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTHFD1" {...geneGroupProps("MTHFD1", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M374 569C374 566.791 375.791 565 378 565H489C491.209 565 493 566.791 493 569V605C493 607.209 491.209 609 489 609H378C375.791 609 374 607.209 374 605V569Z"
                fill={mthfd1.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={390.492} y={595.16}>
                  MTHFD1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mthfd1"
              groupId="gene-snps_3"
              genePalette={mthfd1}
              startX={382}
              startY={611}
              snpCount={getGeneSnpCount("MTHFD1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTHFR" {...geneGroupProps("MTHFR", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M599 795C599 792.791 600.791 791 603 791H703C705.209 791 707 792.791 707 795V831C707 833.209 705.209 835 703 835H603C600.791 835 599 833.209 599 831V795Z"
                fill={mthfr.lozengeFill}
              />
              <text
                id="gene-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={615.266} y={821.16}>
                  MTHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mthfr"
              groupId="gene-snps_4"
              genePalette={mthfr}
              startX={607}
              startY={837}
              snpCount={getGeneSnpCount("MTHFR", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgNutritionFolateDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={860}
    viewBox="0 176 1024 860"
    fill="none"
    {...props}
  >
    <NutritionFolateDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18284_196610">
        <rect width={1024} height={1036} fill="white" />
      </clipPath>
      <clipPath id="clip1_18284_196610">
        <rect width={1024} height={860} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNutritionFolateDiagram;
